var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"20","width":"20","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M14 7L9.97 13L6 7H14Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }